export default interface ModalState {
    id: string;
    show: boolean;
    onClose?: () => void;
    option?: ModalOptions;
    onTrueAction?: () => void;
    onFalseAction?: () => void;
}

export enum ModalActionSource {
    Default = 'homepage',
    StyleQuiz = 'style-quiz',
}

export interface ModalOptions {
    redirectUrl?: string;
    modalActionSource?: ModalActionSource;
    previewLocation?: string;
}
